import { useTranslation } from "react-i18next";
import { usePaginatedQuery } from "../../../Hooks/usePaginatedQuery";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { buildParams } from "../../../Components/Utility/URLUtils";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import { TableNavigation } from "../../../Components/Tables/Vehicles/TableNavigation";
import DataTable from "../../../Components/DataTable/DataTable";
import DebouncedInput from "../../../Components/Inputs/NewDebouncedInput";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import instance from "../../../Interceptor/api_instance";
import { convertToPST } from "../../../Helper/FormatDatetimes";

const DEFAULT_URL = "safety/seals/";

const sealsColumns = (t) => [
  {
    key: "datetime",
    header: t("yard-tables.table-columns.datetime"),
    getValue: (row) => convertToPST(row.check_in.trailer.check_in_dt),
  },
  {
    key: "sealNumber",
    header: t("yard-tables.table-columns.seal"),
    getValue: (row) => row.seal_number,
  },
  {
    key: "trailer",
    header: t("yard-tables.table-columns.trailer"),
    getValue: (row) => row.check_in.trailer.trailer_number,
  },
  {
    key: "isLoaded",
    header: t("yard-tables.table-columns.isLoaded"),
    getValue: (row) => row.check_in.is_loaded,
  },
  {
    key: "driverName",
    header: t("yard-tables.table-columns.driver"),
    getValue: (row) => row.check_in.visitor.full_name,
  },
  {
    key: "driverLicense",
    header: t("yard-tables.table-columns.driverLicense"),
    getValue: (row) => row.check_in.visitor.id_num,
  },
  {
    key: "employeeName",
    header: t("yard-tables.table-columns.guard"),
    getValue: (row) => row.check_in.employee?.full_name,
  },
];

export const F23Table = () => {
  const { t } = useTranslation();
  const columns = sealsColumns(t);

  const navigate = useNavigate();

  // Active filter values - kept in sync with the debounced input
  const [filters, setFilters] = useState({
    seal_number: "",
    start_date: null,
    end_date: null,
    is_assigned: true,
    ordering: "-check_in_dt"
  });

  const { state, dispatch, setPage } = usePaginatedQuery(
    `${DEFAULT_URL}?${buildParams(filters)}`
  );

  const {
    mutate: exportSeals,
    isLoading,
    error,
  } = useApiMutation(async ({ signal }) => {
    const response = await instance.post("/files/export-ctpat-f23/", filters, {
      signal,
    });
    if (response.status === 201) {
      navigate("/export-jobs");
    } else {
      return response;
    }
  });

  const handleFilter = (name, value) => {
    const newFilters = { ...filters, [name]: value };
    setFilters((prev) => ({ ...prev, [name]: value }));
    setPage(`${DEFAULT_URL}?${buildParams(newFilters)}`);
  };

  return (
    <>
      {error && <p className="error">{error}</p>}
      <div className="search-filters-cont">
        <div className="search-filters">
          <label>
            {t("searchFilters.startDate")}
            {": "}
            <input
              type="date"
              className="text-input-sm"
              name="start_date"
              onChange={(e) => handleFilter("start_date", e.target.value)}
              value={filters.start_date || ""}
            />
          </label>
          <label>
            {t("searchFilters.endDate")}
            {": "}
            <input
              type="date"
              name="end_date"
              className="text-input-sm"
              onChange={(e) => handleFilter("end_date", e.target.value)}
              value={filters.end_date || ""}
            />
          </label>
          <DebouncedInput
            label={"seal"}
            name={"seal_number"}
            state={filters.seal_number}
            setState={handleFilter}
          />
          {isLoading ? (
            <Spinner />
          ) : (
            <button className="all-btn other-btn" onClick={exportSeals}>
              {t("buttons.export")}
            </button>
          )}
        </div>
        <TableNavigation state={state} dispatch={dispatch} />
      </div>
      <DataTable
        columns={columns}
        rows={state.data}
        isLoading={state.isLoading}
      />
    </>
  );
};

export default F23Table;
